import React from "react";
import DashboardPage from "../pages/DashboardPage";
import AcademicYearsPage from "../pages/AcademicYearsPage";
import AssessmentsPage from "../pages/AssessmentsPage";
import BranchesPage from "../pages/BranchesPage";
import EnrollmentsPage from "../pages/EnrollmentsPage";
import FeeStructuresPage from "../pages/FeeStructuresPage";
import ParentsPage from "../pages/ParentsPage";
import RolesAndPermissionsPage from "../pages/RolesAndPermissionsPage";
import StudentsPage from "../pages/StudentsPage";
import SubjectsPage from "../pages/SubjectsPage";
import SuppliersPage from "../pages/SuppliersPage";
import TeachersPage from "../pages/TeachersPage";
import TimetablesPage from "../pages/TimetablesPage";
import UsersPage from "../pages/UsersPage";
import GradeLevelsPage from "../pages/GradeLevelsPage";
import TermsPage from "../pages/TermsPage";
import ClassroomsPage from "../pages/ClassroomsPage";
import VoteHeadsPage from "../pages/VoteHeadsPage";
import TeacherSubjectsPage from "../pages/TeacherSubjectsPage";
import TimeslotsPage from "../pages/TimeslotsPage";
import CurriculumRequirementsPage from "../pages/CurriculumRequirementsPage";
import TimetableSlotsPage from "../pages/TimetableSlotsPage";
import InventoryItemsPage from "../pages/InventoryItemsPage";
import StockLevelsPage from "../pages/StockLevelsPage";
import SmsTemplatesPage from "../pages/SmsTemplatesPage";
import SmsOutboxPage from "../pages/SmsOutboxPage";
import FeeAllocationsPage from "../pages/FeeAllocationsPage";
import AnnouncementsPage from "../pages/AnnouncementsPage";
import InventoryLogsPage from "../pages/InventoryLogsPage";
import AttendanceRecordsPage from "../pages/AttendanceRecordsPage";
import StudentsTermReportsPage from "../pages/StudentsTermReportsPage";
import NewslettersPage from "../pages/NewslettersPage";
import TransitionRecordsPage from "../pages/TransitionRecordsPage";
import BankTransactionsStagingPage from "../pages/BankTransactionsStagingPage";
import StudentFeeLedgersPage from "../pages/StudentFeeLedgersPage";
import AuditLogsPage from "../pages/AuditLogsPage";
import NotificationsPage from "../pages/NotificationsPage";
import PurchaseOrdersPage from "../pages/PurchaseOrdersPage";
import PurchaseOrderPage from "../pages/PurchaseOrderPage";
import CreatePurchaseOrderPage from "../pages/CreatePurchaseOrderPage";
import PaymentsPage from "../pages/PaymentsPage";

const Placeholder = ({ title }: { title?: string }): React.ReactElement => (
  <div style={{ padding: "2rem" }}>
    <h1>{title || "Page Under Construction"}</h1>
  </div>
);

const RouteToComponentMapper: Record<string, React.ElementType> = {
  DASHBOARD: DashboardPage,

  // Academics
  CLASSROOMS: ClassroomsPage,
  SUBJECTS: SubjectsPage,
  TEACHER_SUBJECTS: TeacherSubjectsPage,
  TIMESLOTS: TimeslotsPage,
  CURRICULUM_REQUIREMENTS: CurriculumRequirementsPage,
  TIMETABLE_SLOTS: TimetableSlotsPage,
  TIMETABLES: TimetablesPage,
  ASSESSMENTS: AssessmentsPage,
  ATTENDANCE_RECORDS: AttendanceRecordsPage,
  ACADEMIC_YEARS: AcademicYearsPage,
  TERMS: TermsPage,
  GRADE_LEVELS: GradeLevelsPage,
  STUDENT_TERM_REPORTS: StudentsTermReportsPage,
  TRANSITION_RECORDS: TransitionRecordsPage,

  // People
  STUDENTS: StudentsPage,
  TEACHERS: TeachersPage,
  PARENTS: ParentsPage,
  ENROLLMENTS: EnrollmentsPage,

  // Finance
  VOTE_HEADS: VoteHeadsPage,
  FEE_STRUCTURES: FeeStructuresPage,
  FEE_ALLOCATIONS: FeeAllocationsPage,
  BANK_STAGING: BankTransactionsStagingPage,
  STUDENT_FEE_LEDGERS: StudentFeeLedgersPage,
  PAYMENTS: PaymentsPage,

  // Comms
  ANNOUNCEMENTS: AnnouncementsPage,
  NOTIFICATIONS: NotificationsPage,
  SMS_TEMPLATES: SmsTemplatesPage,
  SMS_OUTBOX: SmsOutboxPage,
  NEWSLETTERS: NewslettersPage,

  // Inventory
  INVENTORY: InventoryItemsPage,
  STOCK_LEVELS: StockLevelsPage,
  INVENTORY_LOGS: InventoryLogsPage,

  // Procurement
  SUPPLIERS: SuppliersPage,
  PURCHASE_ORDERS: PurchaseOrdersPage,
  PURCHASE_ORDER_CREATE: CreatePurchaseOrderPage,
  PURCHASE_ORDER: PurchaseOrderPage,

  // Admin
  BRANCHES: BranchesPage,
  USERS: UsersPage,
  ROLES: RolesAndPermissionsPage,
  AUDIT_LOGS: AuditLogsPage,
};

export default RouteToComponentMapper;
